import { GridWidths } from '../../models/types/theming';

const gridWidths: GridWidths = {
  240: 240,
  360: 360,
  400: 400,
  600: 600,
  900: 900,
  1008: 1008,
  1280: 1280,
};

export default gridWidths;
